module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "addcashier"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    staticClass: "first",
    attrs: {
      "to": {
        path: '/main/cashiermanage'
      },
      "replace": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L3')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.add.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper",
    class: {
      'wrapper': _vm.lang === 'ja' || _vm.lang === 'en'
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.name'),
      "prop": "opname"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": _vm.$t('cashMng.common.m5')
    },
    model: {
      value: (_vm.form.opname),
      callback: function($$v) {
        _vm.$set(_vm.form, "opname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.opname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.mobile'),
      "prop": "mobile"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": _vm.$t('cashMng.common.m6')
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.user')
    }
  }, [_c('span', {
    staticClass: "input-content"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.number')
    }
  }, [_c('span', {
    staticClass: "input-content"
  }, [_vm._v(_vm._s(_vm.opuid))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('cashMng.common.m7')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.tip1')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelCreat
    }
  }, [_vm._v(_vm._s(_vm.$t('cashMng.add.btn1')))]), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.loading1) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('cashMng.add.btn2')))])]) : _vm._e()])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1e245ca8"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/addcashier/addcashier.vue
// module id = 908
// module chunks = 0